var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFixlyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    rx: 2,
    fill: "#FFD700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86409 7.6135C7.16503 7.91408 7.33082 8.31372 7.33082 8.73889C7.33082 8.74441 7.3306 8.75004 7.3306 8.75555C8.10281 7.99249 11.573 4.56343 11.5745 4.56181L10.0412 3L6.08105 6.83141L6.86409 7.6135Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.22908 9.2137C6.04674 9.39441 5.75103 9.39441 5.5687 9.2137C5.38636 9.033 5.38636 8.73994 5.5687 8.55923C5.75103 8.37853 6.04674 8.37853 6.22908 8.55923C6.41141 8.73994 6.41141 9.033 6.22908 9.2137ZM6.68458 8.04725L6.3524 7.71805L3.63222 5.02222L2 6.63994L4.72007 9.33578L5.05236 9.66498C5.50308 10.1117 6.23386 10.1117 6.68458 9.66498C7.1353 9.21829 7.1353 8.49405 6.68458 8.04725Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixlyLogo);
export default __webpack_public_path__ + "static/media/fixly-logo.886c7507.svg";
export { ForwardRef as ReactComponent };